/* 3 sep (wiswiz #154): de betaalknop zegt wat je betaalt. Art. 6:230v lid 3 BW wil de betaalplicht onmiskenbaar op de
   knop; "Verifieer je betaalmethode" zei dat niet. De proefweek-belofte blijft in dezelfde regel staan. Pure functie,
   zodat de knoptekst per route testbaar is zonder React.
   5 sep (wiswiz #172, Philips order): op /voor-ouders/start staat de betaalplicht NIET meer op de knop zelf maar in de
   regel direct eronder (START_PROEFWEEK_BUTTON_TEXT). Dat is een bewuste afweging (conversie boven de #154-lezing van
   6:230v), vastgelegd op kaart #172; de andere routes houden de #154-knop. */

export type CheckoutTrialStatus = "not_started" | "during" | "expired";

/* De €0,01-validatiestap (proefweek nog niet gestart) op de pakketroute /parentemailcheckout en de ingelogde
   checkouts, waar de feitenregel al zegt "Vandaag betaal je €0,01 om je betaalmethode te verifiëren."
   (/voor-ouders/start heeft sinds #172 zijn eigen knoptekst, hieronder.) */
export const TRIAL_VALIDATION_BUTTON_TEXT = "Betaal €0,01 en start de gratis proefweek";

/* 5 sep (wiswiz #172, Philip: 'keep the button what it was when the ad was most effective'): op de betaalpagina van de
   ouderroute (/voor-ouders/start) heet de knop weer 'Start de gratis proefweek' — dezelfde woorden als de knop op
   /voor-ouders die de ouder hierheen bracht. Sinds de €0,01-knop van #154 (3 sep 20:46) typte 0 van 17 bezoekers een
   adres; ervoor betaalden 4 van 10. De €0,01-uitleg staat als kleine regel direct ONDER de knop (zie
   AanbiedingParentPayment), zodat de betaalplicht in beeld blijft. De andere routes houden TRIAL_VALIDATION_BUTTON_TEXT. */
export const START_PROEFWEEK_BUTTON_TEXT = "Start de gratis proefweek";

export function checkoutButtonText({
  isResumeFlow,
  isParent,
  trialStatus,
  priceLabel
}: {
  isResumeFlow: boolean;
  isParent: boolean;
  trialStatus: CheckoutTrialStatus;
  /* zoals formatPlanPriceLabel het geeft: "€ 84 per jaar", "€ 11 per maand", "€ 200 eenmalig" */
  priceLabel: string;
}): string {
  if (isResumeFlow) return "Hervat abonnement";

  if (trialStatus === "not_started") return TRIAL_VALIDATION_BUTTON_TEXT;

  /* tijdens de proefweek is de knop geen betaling (ouder: uitnodiging maken; leerling: abonnement na de proefweek) */
  if (trialStatus === "during") return isParent ? "Maak uitnodiging aan" : "Start abonnement";

  /* de gewone route: het bedrag op de knop, in dezelfde schrijfwijze als 'Mijn bestelling' erboven */
  return `Betaal ${priceLabel}`;
}
